// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#category .category-teaser[data-v-5b053e8a] a{color:#fff}#category .category-teaser[data-v-5b053e8a] .teaser-subtitle{display:block}#category .category-content[data-v-5b053e8a]{margin-top:15px}@media(max-width:991.98px){#category .category-teaser[data-v-5b053e8a] .teaser-subtitle{display:none}}#category .category__empty-alert[data-v-5b053e8a]{align-items:center;display:flex;height:200px;justify-content:center;margin-top:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
